export const TRANSFER_QUOTE_REFRESH_MARGIN_MS = 30_000;

export function getTransferQuoteRefreshDelay(expiresAt: string) {
  const expiresAtMs = Date.parse(expiresAt);
  if (!Number.isFinite(expiresAtMs)) return 0;
  return Math.max(0, expiresAtMs - Date.now() - TRANSFER_QUOTE_REFRESH_MARGIN_MS);
}
